import z from 'zod';
import {tradeMessageWriteSchema} from './tradeMessageWriteSchema';

export const tradeMessageDbSchema = tradeMessageWriteSchema;

export type TradeMessageDb = z.infer<typeof tradeMessageDbSchema>;
